export type BankingProviderId = 'jack_henry_silverlake' | 'jack_henry_synergy' | (string & {})

/** Per-section access: write implies read at the token layer. */
export type BankingPermissionTier = 'none' | 'read' | 'write'

const TIER_RANK: Record<BankingPermissionTier, number> = {
  none: 0,
  read: 1,
  write: 2
}

export function maxBankingPermissionTier(
  a: BankingPermissionTier,
  b: BankingPermissionTier
): BankingPermissionTier {
  return TIER_RANK[a] >= TIER_RANK[b] ? a : b
}

export function isBankingPermissionTier(value: unknown): value is BankingPermissionTier {
  return value === 'none' || value === 'read' || value === 'write'
}

export interface BankingCapabilities {
  customers: BankingPermissionTier
  accounts: BankingPermissionTier
  transfers: BankingPermissionTier
  transactions: BankingPermissionTier
  loan: BankingPermissionTier
  rdcRequests: BankingPermissionTier
  rdcAccounts: BankingPermissionTier
  rdcVelocity: BankingPermissionTier
}

export const DEFAULT_BANKING_CAPABILITIES: BankingCapabilities = {
  customers: 'none',
  accounts: 'none',
  transfers: 'none',
  transactions: 'none',
  loan: 'none',
  rdcRequests: 'none',
  rdcAccounts: 'none',
  rdcVelocity: 'none'
}

export const FULL_BANKING_CAPABILITIES: BankingCapabilities = {
  customers: 'write',
  accounts: 'write',
  transfers: 'write',
  transactions: 'write',
  loan: 'write',
  rdcRequests: 'write',
  rdcAccounts: 'write',
  rdcVelocity: 'write'
}

export const BANKING_CAPABILITY_KEYS = Object.keys(
  DEFAULT_BANKING_CAPABILITIES
) as (keyof BankingCapabilities)[]
